import { Injectable } from '@angular/core';
import { StringKeyValue } from '../modules/shared/model/stringKeyValue.model';


@Injectable({
  providedIn: 'root'
})
export class ApiProviderProdService {

  constructor() { }

  get nativeWindow(): Window {
    return window;
  }

  get apiUrl(): any {
    const win: any = window;
    return win.location.protocol + '//' + win.location.host + win.DATA.vdir;
  }

  get vDir(): any {
    const win: any = window;
    if (win) {
      return win.DATA.vdir;
    } else {
      // headless/testing mode
      return '';
    }
  }

  getApiUrl(url: string, params?: StringKeyValue[]): string {
    let apiUrl = `${window.location.protocol}//${window.location.host}${(window as any).DATA.vdir}${url}`;
    if (params) {
      let paramString = '';
      params.forEach(kvp => {
        paramString += '&' + kvp.Key + '=' + kvp.Value;
      });
      apiUrl += paramString.replace('&', '?'); // replaces first instance of & only
    }

    return apiUrl;
  }

  getCustomizationUrl(url: string): string {
    const agencyCode = (window as any).DATA.vdir;
    const customizationUrl = `${window.location.protocol}//${window.location.host}${agencyCode}Customization${agencyCode}${url}`;
    return customizationUrl;
  }
}
